<ng-container *ngIf="visible">
  <div class="container htv-contain">
    <div class="vod-tracks-menu-content">
      <div class="tracks-container">
        <div class="audio-container">
          <div class="title">
            <span>{{ 'CHANNEL_SUBTITLE.AUDIO_TITLE' | translate }}</span>
          </div>
          <div class="content">
            <div
              *ngFor="let track of extendedAudioTracks"
              class="track htv-selectable"
              [class.active]="track.data.index === currentAudioTrack?.data?.index"
              (click)="setAudioTrack(track.data)"
              tabindex="-1">
              <div class="tick">
                <mat-icon *ngIf="track.data.index === currentAudioTrack?.data?.index">check</mat-icon>
              </div>
              <div class="label">
                <span>{{ track.nativeLanguage | titlecase }}</span>
                <span *ngIf="track.data.flags.indexOf(ChannelTrackDataFlags.HEARING_IMPAIRED) > -1">
                  ({{ 'CHANNEL_SUBTITLE.CLOSED_CAPTION.FULL' | translate }})
                </span>
                <span *ngIf="track.data.flags.indexOf(ChannelTrackDataFlags.VISUAL_IMPAIRED) > -1">
                  ({{ 'CHANNEL_SUBTITLE.AUDIO_DESCRIPTION.FULL' | translate }})
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="subtitle-container">
          <div class="title">
            <span>{{ 'CHANNEL_SUBTITLE.SUBTITLE_TITLE' | translate }}</span>
          </div>
          <div class="content">
            <div
              *ngFor="let track of extendedSubtitleTracks"
              class="track htv-selectable"
              [class.active]="isSubtitleEnabled && track.data.index === currentSubtitleTrack?.data?.index"
              (click)="setSubtitleTrack(track.data)"
              tabindex="-1">
              <div class="tick">
                <ng-container *ngIf="isSubtitleEnabled && track.data.index === currentSubtitleTrack?.data?.index">
                  <mat-icon>&#xe5ca;</mat-icon>
                </ng-container>
              </div>
              <div class="label">
                <span>{{ track.nativeLanguage | titlecase }}</span>
                <span *ngIf="track.data.flags.indexOf(ChannelTrackDataFlags.HEARING_IMPAIRED) > -1">
                  ({{ 'CHANNEL_SUBTITLE.CLOSED_CAPTION.FULL' | translate }})
                </span>
                <span *ngIf="track.data.flags.indexOf(ChannelTrackDataFlags.VISUAL_IMPAIRED) > -1">
                  ({{ 'CHANNEL_SUBTITLE.AUDIO_DESCRIPTION.FULL' | translate }})
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="close-button htv-raised-button htv-selectable htv-focus"
      mat-raised-button
      color="primary"
      (click)="close()">
      <mat-icon>&#xe5cd;</mat-icon>
      <span>{{ 'CLOSE' | translate }}</span>
    </button>
  </div>
</ng-container>
